export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="relative rounded-2xl overflow-hidden mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20of%20curated%20fashion%20and%20lifestyle%20products%20including%20sneakers%2C%20watches%2C%20leather%20bags%2C%20sunglasses%2C%20and%20accessories%20arranged%20in%20a%20beautiful%20circular%20composition%20on%20a%20warm%20sandstone%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20catalog%20photography%2C%20earthy%20minimal%20tones%2C%20sophisticated%20product%20curation%20display&width=1400&height=700&seq=cta-banner-v2&orientation=landscape"
              alt="Vigorbuy Spreadsheet product collection showcase"
              title="Explore Vigorbuy Spreadsheet Products"
              className="w-full h-[280px] md:h-[360px] object-cover object-top"
              loading="lazy"
            />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Ready to <span className="italic font-normal text-foreground-400">Discover</span> Your
            <br />
            <span className="text-primary-500">Next Favorite Product</span>?
          </h2>

          <p className="mt-4 text-base text-foreground-500 max-w-xl mx-auto">
            Join thousands of savvy shoppers who use the Vigorbuy Spreadsheet to find, compare, and purchase products with confidence.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-shopping-bag-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              vigorbuy sheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}